import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: 24px;

  margin-bottom: 24px;

  flex-wrap: wrap;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;

  gap: 6px;
`;

export const Title = styled.h2`
  margin: 0;

  font-size: 28px;
  font-weight: 700;

`;

export const Subtitle = styled.p`
  margin: 0;

  font-size: 14px;

  color: #6B7280;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;

  gap: 12px;

  flex-wrap: wrap;
`;